// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type CustomerInfoWithoutInvoicedCityTaxFragment = { __typename?: 'CustomerInfoWithoutInvoicedCityTaxDTO', checkInDate: LocalDate, checkOutDate: LocalDate, name: string | null, reservationId: number, roomNumber: string, surname: string };

export const CustomerInfoWithoutInvoicedCityTaxFragment = gql`
    fragment CustomerInfoWithoutInvoicedCityTax on CustomerInfoWithoutInvoicedCityTaxDTO {
  checkInDate
  checkOutDate
  name
  reservationId
  roomNumber
  surname
}
    `;
/* eslint-enable */